import React from 'react';
import { Flex, Input, Label, Select, ThemeUIStyleObject } from 'theme-ui';

import {
  Contains,
  ContainsLogic,
  ContainsLogicEnum,
  OnChangeComponentParams,
} from '../types';

type Props = {
  contains: Contains;
  containsLogic: ContainsLogic;
  onChange: (changed: OnContainsChangeParams) => void;
};
export type OnContainsChangeParams = OnChangeComponentParams<Props>;

const CONTAINS_LOGIC_DISPLAY_VALUES = {
  [ContainsLogicEnum.AND]: 'all',
  [ContainsLogicEnum.OR]: 'any',
  [ContainsLogicEnum.ONLY]: 'only',
};

const styles: Record<string, ThemeUIStyleObject> = {
  label: {
    alignItems: 'center',
    width: 'auto',
    marginRight: 2,
  },
  input: {
    maxWidth: '130px',
    marginLeft: 2,
  },
  select: {
    marginLeft: 2,
  },
};

export const ContainsComponent: React.FC<Props> = ({
  contains,
  containsLogic,
  onChange,
}) => (
  <Flex px={3} mt={3}>
    <Label htmlFor="contains" sx={styles.label}>
      contains
      <Input
        id="contains"
        value={contains}
        sx={styles.input}
        onChange={event =>
          onChange({ contains: event.target.value, containsLogic })
        }
      />
    </Label>
    <Label htmlFor="contains-logic" sx={styles.label}>
      logic
      <Select
        id="contains-logic"
        value={containsLogic}
        sx={styles.select}
        onChange={event =>
          onChange({
            contains,
            containsLogic: event.target.value as ContainsLogic,
          })
        }>
        {Object.entries(CONTAINS_LOGIC_DISPLAY_VALUES).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </Select>
    </Label>
  </Flex>
);
